import { useMsal } from "@azure/msal-react";
import { Outlet, Navigate } from "react-router-dom";

const PrivateRoutes = () => {
  const { instance } = useMsal();
  const isAuthenticated = instance.getAllAccounts().length > 0;

  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoutes;
